(function () {
  if (customElements.get('ce-product-quantity') !== undefined) {
    return;
  }

  class ProductQuantity extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        product: 'ce-product',
        input: '[data-product-quantity-input]',
        buttonDecrement: '[data-product-quantity-button="decrement"]',
        buttonIncrement: '[data-product-quantity-button="increment"]',
        json: '[data-product-quantity-json]',
      };

      this.elements = null;
      this.variants = null;

      this.handleProductVariantId = this.handleProductVariantId.bind(this);
      this.handleChangeInput = this.handleChangeInput.bind(this);
      this.handleBlurInput = this.handleBlurInput.bind(this);
      this.handleClickButtonDecrement = this.handleClickButtonDecrement.bind(this);
      this.handleClickButtonIncrement = this.handleClickButtonIncrement.bind(this);
    }

    get variantId() {
      return this.getAttribute('variant-id');
    }

    set variantId(value) {
      this.setAttribute('variant-id', value);
    }

    static get observedAttributes() {
      return ['variant-id'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'variant-id':
          if (newValue !== null) {
            const variant = this.variants[newValue];

            this.elements.input.value = 1;
            this.elements.input.dataset.min = 1;
            this.elements.buttonDecrement.setAttribute('aria-disabled', 'true');

            if (variant.available) {
              this.elements.input.removeAttribute('aria-disabled');
            } else {
              this.elements.input.setAttribute('aria-disabled', 'true');
            }

            if (variant.available && variant.inventoryManagement !== null && variant.inventoryPolicy == 'deny') {
              this.elements.input.dataset.max = variant.inventoryQuantity;
            } else {
              delete this.elements.input.dataset.max;
            }

            if (variant.inventoryManagement !== null && variant.inventoryPolicy == 'deny' && variant.inventoryQuantity <= 1) {
              this.elements.buttonIncrement.setAttribute('aria-disabled', 'true');
            } else {
              this.elements.buttonIncrement.removeAttribute('aria-disabled');
            }
          }

          break;
      }
    }

    parsedCallback() {
      this.elements = {
        product: this.closest(this.selectors.product),
        input: this.querySelector(this.selectors.input),
        buttonDecrement: this.querySelector(this.selectors.buttonDecrement),
        buttonIncrement: this.querySelector(this.selectors.buttonIncrement),
        json: this.querySelector(this.selectors.json),
      };

      this.variants = JSON.parse(this.elements.json.textContent);
      this.elements.json.remove();

      this.elements.product.addEventListener('ce-product:variant-id', this.handleProductVariantId);

      this.elements.input.addEventListener('change', this.handleChangeInput);
      this.elements.input.addEventListener('blur', this.handleBlurInput);
      this.elements.buttonDecrement.addEventListener('click', this.handleClickButtonDecrement);
      this.elements.buttonIncrement.addEventListener('click', this.handleClickButtonIncrement);

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      this.elements.product.removeEventListener('ce-product:variant-id', this.handleProductVariantId);

      this.elements.input.removeEventListener('change', this.handleChangeInput);
      this.elements.input.removeEventListener('blur', this.handleBlurInput);
      this.elements.buttonDecrement.removeEventListener('click', this.handleClickButtonDecrement);
      this.elements.buttonIncrement.removeEventListener('click', this.handleClickButtonIncrement);
    }

    handleProductVariantId(event) {
      this.variantId = event.detail;
    }

    handleChangeInput() {
      if (this.elements.input.value > 1) {
        this.elements.buttonDecrement.removeAttribute('aria-disabled');
      } else {
        this.elements.buttonDecrement.setAttribute('aria-disabled', 'true');
      }

      if ('max' in this.elements.input.dataset) {
        const max = parseInt(this.elements.input.dataset.max);
        if (this.elements.input.value < max) {
          this.elements.buttonIncrement.removeAttribute('aria-disabled');
        } else {
          this.elements.buttonIncrement.setAttribute('aria-disabled', 'true');
        }
      }
    }

    handleBlurInput() {
      if (this.elements.input.hasAttribute('aria-disabled')) {
        this.elements.input.value = 1;
        return;
      }

      const value = parseInt(this.elements.input.value) || 0;

      if ('max' in this.elements.input.dataset) {
        const max = parseInt(this.elements.input.dataset.max);
        const newValue = Math.max(1, Math.min(max, value));

        if (newValue !== value) {
          this.elements.input.value = newValue;
          this.elements.input.dispatchEvent(new Event('change'));
        }
      } else {
        const newValue = Math.max(1, value);

        if (newValue !== value) {
          this.elements.input.value = newValue;
          this.elements.input.dispatchEvent(new Event('change'));
        }
      }
    }

    handleClickButtonDecrement(event) {
      if (this.elements.buttonDecrement.hasAttribute('aria-disabled')) {
        event.preventDefault();
        return;
      }

      const value = parseInt(this.elements.input.value);
      this.elements.input.value = value - 1;

      this.elements.input.dispatchEvent(new Event('change'));
    }

    handleClickButtonIncrement(event) {
      if (this.elements.buttonIncrement.hasAttribute('aria-disabled')) {
        event.preventDefault();
        return;
      }

      const value = parseInt(this.elements.input.value);
      this.elements.input.value = value + 1;

      this.elements.input.dispatchEvent(new Event('change'));
    }

    getQuantity() {
      return parseInt(this.elements.input.value);
    }
  }

  customElements.define('ce-product-quantity', ProductQuantity);
})();
